import { message as $message } from 'antd'
import omit from 'lodash/omit'
import {
    AFTERSALES_PLATFORM_TAOBAO,
    AFTERSALES_PLATFORM_WXCHANNEL,
    AFTERSALES_PLATFORM_BILIBILI
} from '@/modules/order/constants'
import { ActionType } from '@/modules/afterSale/constants/afterSalesOrderAction'
import { hasSpecialRefundOrder } from '@/modules/order/utils/checkAfterSales/specialRefundOrder'
import { allowAsyncProcessingRefund } from '@/modules/order/utils/checkAfterSales/allowAsyncProcessingRefund.ts'
import { afterSaleRefundStore } from '@/modules/afterSale/store/afterSaleRefundSupport'

// 选择项检查
export const checkHasSelected = ({ selectedRows }) => {
    if (!Array.isArray(selectedRows) || !selectedRows.length) {
        $message.error('请选择售后单！')
        return false
    }

    return true
}

const getMsg = ({ type } = {}) => {
    const { supportLabel, notSupportListConfig } = afterSaleRefundStore.getState()
    // 为了不修改原数据
    let tempSupportLabel = [...supportLabel]

    for (let index = 0; index < notSupportListConfig.length; index++) {
        const element = notSupportListConfig[index]
        if (element.notSupportActionList.includes(type)) {
            tempSupportLabel = tempSupportLabel.filter(v => v !== element.label)
        }
    }
    return `暂只支持${tempSupportLabel.join(',')}平台的线上售后处理，其他平台暂不支持`
}
export const getPlatfromMap = ({ type } = {}) => {
    const { supportPlatformMap, notSupportListConfig } = afterSaleRefundStore.getState()
    // 为了不修改原数据
    let tempSupportPlatformMap = { ...supportPlatformMap }

    for (let index = 0; index < notSupportListConfig.length; index++) {
        const element = notSupportListConfig[index]
        if (element.notSupportActionList.includes(type)) {
            tempSupportPlatformMap = omit(tempSupportPlatformMap, [element.omitPlatForm])
        }
    }
    return tempSupportPlatformMap
}

// 检测是否单个售后单
const checkIsSingle = ({ selectedRows }) => {
    return Array.isArray(selectedRows) && selectedRows.length === 1
}

// 检测是否都在支持的平台内（只支持：淘宝，天猫，拼多多，抖音，快手），
export const checkIsInPlatform = ({ selectedRows, toast = false, type }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        // 存在不支持的平台
        const hasNotInRange = selectedRows.some(v => !Object.keys(getPlatfromMap({ type })).includes(v.shopSite))

        if (hasNotInRange) {
            toast && $message.error(getMsg({ type }))
            return false
        }

        return true
    }

    return false
}

// 检测是否都是支持的平台
export const checkIsAllInPlatform = ({ selectedRows, toast = false, type }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        // 都是不支持的平台
        const isNotInInRange = selectedRows.every(v => !Object.keys(getPlatfromMap({ type })).includes(v.shopSite))

        if (isNotInInRange) {
            toast && $message.error(getMsg({ type }))
            return false
        }

        return true
    }

    return false
}
// 检测是否是勾选的多个视频号平台的售后单
export const checkIsMultipleWxChannel = ({ selectedRows, type, toast = false }) => {
    if (allowAsyncProcessingRefund(type)) {
        return true
    }

    if (Array.isArray(selectedRows) && selectedRows.length) {
        const isWxChannelRows = selectedRows.filter(v => v.shopSite === AFTERSALES_PLATFORM_WXCHANNEL)

        if (isWxChannelRows?.length > 1) {
            toast && $message.error('微信小店平台暂只支持单条处理售后，批量操作请等待后续升级~')
            return false
        }

        return true
    }

    return false
}
// 检测是否是勾选的多个B站会员购平台的售后单
export const checkIsMultipleBliBli = ({ selectedRows, type, toast = false }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        const isAccordRows = selectedRows.filter(v => v.shopSite === AFTERSALES_PLATFORM_BILIBILI)

        if (isAccordRows?.length > 1 && type === ActionType.REFUND) {
            toast && $message.error(`${AFTERSALES_PLATFORM_BILIBILI}平台暂只支持单条处理售后，批量操作请等待后续升级~`)
            return false
        }

        return true
    }

    return false
}

// 检测是否都是线上下载
export const checkIsOnlineDownload = ({ selectedRows, toast = false }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        // 存在手工创建
        const hasNotOnlineDownload = selectedRows.some(v => !v.onlineDownload)

        if (hasNotOnlineDownload) {
            toast && $message.error('只支持线上下载的售后单处理，手工创建的售后单不支持')
            return false
        }

        return true
    }

    return false
}

// 检测是否都是手工创建
export const checkIsAllOnlineDownload = ({ selectedRows, toast = false }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        // 都是手工创建的
        const isNotOnlineDownload = selectedRows.every(v => !v.onlineDownload)

        if (isNotOnlineDownload) {
            toast && $message.error('只支持线上下载的售后单处理，手工创建的售后单不支持')
            return false
        }

        return true
    }

    return false
}

// 检测是否都是不支持的店铺或手工创建
export const checkIsAllInPlatformAndOnlineDownload = ({ selectedRows, toast = false, type }) => {
    if (Array.isArray(selectedRows) && selectedRows.length) {
        // 都是不支持平台或手工创建的
        const isInvalid = selectedRows.every(
            v => !v.onlineDownload || !Object.keys(getPlatfromMap({ type })).includes(v.shopSite)
        )

        if (isInvalid) {
            toast && $message.error(getMsg({ type }))
            return false
        }

        return true
    }

    return false
}

// 不同淘系店铺
const checkIsNotSameTaoXiShop = ({ selectedRows, type }) => {
    if (allowAsyncProcessingRefund(type)) {
        return true
    }

    if (Array.isArray(selectedRows) && selectedRows.length) {
        const res = selectedRows.map(v => {
            return {
                isTaoXi: v.shopSite === AFTERSALES_PLATFORM_TAOBAO,
                shopId: v.shopId,
                shopSite: v.shopSite,
                onlineDownload: v.onlineDownload
            }
        })

        const taoXiList = res.filter(v => v.isTaoXi)

        if (taoXiList.length) {
            const isSameShop = taoXiList.every(v => v.shopId === taoXiList[0].shopId)

            // 不同淘系店铺
            if (!isSameShop) {
                // 非淘系列表
                const notTaoXiList = res.filter(v => !v.isTaoXi)

                // 非淘系售后单都是支持的平台外的或手工创建的
                const isNotTaoXiAllValid = checkIsAllInPlatformAndOnlineDownload({ selectedRows: notTaoXiList, type })

                // 非淘系不合法
                if (!isNotTaoXiAllValid) {
                    $message.error('请选择相同淘宝店铺的售后单')
                    return false
                }
            }
        }

        return true
    }

    return false
}

/** 检查是否包含特殊退款单 */
export function checkIsSpecialRefundOrder({ selectedRows, toast = false }) {
    if (!hasSpecialRefundOrder(selectedRows)) {
        return true
    }

    toast && $message.error('标签包含【特殊退款单】的售后单需前往平台后台操作')
    return false
}

// 检查选中项
export const checkSelected = ({ selectedRows, multipleCheck = false, type }) => {
    console.log('checkSelected', type)
    if (!checkHasSelected({ selectedRows })) {
        return false
    }

    const isSingle = checkIsSingle({ selectedRows })

    if (isSingle) {
        // 单笔
        // 同意退款、同意退货、同意退货退款、拒绝退款、拒绝退货、买家退货异常，驳回退款
        const fns = [checkIsOnlineDownload, checkIsSpecialRefundOrder, checkIsInPlatform]

        const hasError = fns.some(fn => !fn({ selectedRows, toast: true, type }))

        return !hasError
    }

    if (multipleCheck) {
        // 多笔
        // 同意退款、同意退货、同意退货退款
        const fns = [
            checkIsAllOnlineDownload,
            checkIsSpecialRefundOrder,
            checkIsAllInPlatform,
            checkIsAllInPlatformAndOnlineDownload,
            checkIsMultipleWxChannel,
            checkIsMultipleBliBli,
            checkIsNotSameTaoXiShop
        ]

        const hasError = fns.some(fn => !fn({ selectedRows, toast: true, type }))

        return !hasError
    }

    $message.error('请选择单笔售后单！')

    return false
}
